<template>
  <div class="news">
    <div class="page-header">
      <div class="cover">
        <h1 class="has-text-white is-family-secondary">
          Student <br />
          Hub
        </h1>
      </div>
    </div>
    <div class="container section tw-mt-5">
      <div class="section-block tw-justify-between">
        <span class="title tw-text-black tw-mb-0">
          RECENT <span class="tw-font-thin">POSTS</span>
        </span>
        <b-select
          @input="getPosts"
          class="tw-flex tw-items-center tw-uppercase tw-text-base tw-self-center has-text-primary"
          v-model="posts.filter.post_type"
        >
          <option
            v-for="filter in postFilters"
            :value="filter.value"
            :key="filter.value"
          >
            {{ filter.text }}
          </option>
        </b-select>
      </div>

      <promised :promise="postsPromise" v-slot:combined="{ isPending, data }">
        <div class="columns is-multiline tw-mt-4">
          <div class="column is-3 is-flex">
            <div class="scrapbook-new">
              <a
                @click="sharePost"
                href="javascript:;"
                class="share is-family-secondary"
              >
                Share a Post
              </a>
            </div>
          </div>
          <skeleton-loading
            v-if="isPending"
            class="tw-ml-6 column is-3 tw-p-0"
          />
          <template v-else-if="data">
            <div v-for="post in data.data" :key="post.id" class="column is-3">
              <scrapbook-card @report="onPostReported" :post="post" />
            </div>
          </template>
        </div>

        <b-pagination
          class="tw-mt-8"
          v-if="data && data.meta.last_page > 1"
          @change="onPageChanged"
          :total="data.meta.total"
          :current.sync="data.meta.current_page"
          :per-page="data.meta.per_page"
          order="is-centered"
          aria-next-label="Next page"
          aria-previous-label="Previous page"
        >
        </b-pagination>
      </promised>
    </div>

    <create-post-modal @posted="getPosts" ref="createPost" />

    <report-modal ref="reportPost" :post="reportedPost" />
  </div>
</template>

<script>
import ScrapbookCard from '@/components/ScrapbookCard'
import CreatePostModal from '@/components/modals/CreatePost'
import ReportModal from '@/components/modals/Report'
import Post from '@/models/Post'
import * as PostType from '@/utils/consts/PostType'

export default {
  components: {
    ScrapbookCard,
    CreatePostModal,
    ReportModal
  },
  metaInfo: {
    title: 'Student Hub'
  },
  data() {
    return {
      postsPromise: null,
      reportedPost: null,
      postFilters: [
        { text: 'All posts', value: '' },
        { text: 'Prayer', value: PostType.PRAYER },
        { text: 'Story', value: PostType.STORY },
        { text: 'Idea', value: PostType.IDEA }
      ],
      posts: {
        filter: {
          post_type: ''
        },
        meta: {
          current_page: 1
        }
      }
    }
  },
  mounted() {
    this.getPosts()
  },
  methods: {
    sharePost() {
      this.$refs.createPost.open()
    },

    getPosts() {
      this.postsPromise = Post.include('user', 'image')
        .where('post_type', this.posts.filter.post_type)
        .page(this.posts.meta.current_page)
        .limit(11)
        .get()
        .catch(() => {
          this.$router.replace({ name: 'home' })
        })
    },

    onPageChanged(page) {
      this.posts.meta.current_page = page
      this.getPosts()
    },

    onPostReported(post) {
      this.reportedPost = post
      this.$refs.reportPost.open()
    }
  }
}
</script>

<style lang="scss" scoped>
.page-header {
  background: center / cover no-repeat url(/img/student-header.jpg) !important;
}
</style>
